import React from 'react'
const Phone = () =>{
    return(
<svg xmlns="http://www.w3.org/2000/svg" viewBox="1649 75 12.429 18.615">
                                                  
                                                   <path id="Path_113" dataName="Path 113" fill="#fff" className="call-1" d="M12.436,17.564l-2.72-5.285s-1.554.777-1.632.777c-1.71.855-5.285-6.062-3.575-6.994l1.632-.777L3.421,0,1.789.777C-3.806,3.73,5.053,20.983,10.8,18.341,10.882,18.341,12.436,17.564,12.436,17.564Z" transform="translate(1648.993 75)"></path>
                                                </svg>
        )
}
export default Phone